export default {
  "nav.services": "Hizmetler",
  "nav.jurisdictions": "Ülkeler",
  "nav.partnerNetwork": "Partner Ağı",
  "nav.process": "Süreç",
  "nav.blog": "Blog",
  "nav.contact": "İletişim",
  "nav.admin": "Yönetim",
  "nav.signIn": "Giriş Yap",
  "nav.getFreeAnalysis": "Ücretsiz Analiz Al",
  "nav.dashboard": "Dashboard",

  "footer.services": "HİZMETLER",
  "footer.companyFormation": "Şirket Kuruluşu",
  "footer.visaImmigration": "Vize & Göçmenlik",
  "footer.businessExpansion": "İş Geliştirme",
  "footer.legalPartnerNetwork": "Hukuk Partner Ağı",
  "footer.investmentAdvisory": "Yatırım Danışmanlığı",
  "footer.jurisdictions": "ÜLKELER",
  "footer.germany": "Almanya (GmbH)",
  "footer.uk": "İngiltere (Ltd)",
  "footer.usa": "ABD (LLC/C-Corp)",
  "footer.dubai": "Dubai (Free Zone)",
  "footer.estonia": "Estonya (e-Residency)",
  "footer.legal": "YASAL",
  "footer.company": "KURUMSAL",
  "footer.about": "LegalVio Hakkında",
  "footer.ourProcess": "Sürecimiz",
  "footer.faq": "SSS",
  "footer.privacyPolicy": "Gizlilik Politikası",
  "footer.termsOfService": "Kullanım Koşulları",
  "footer.contact": "İletişim",
  "footer.contactTitle": "BİZE ULAŞIN",
  "footer.contactDesc": "Sorularınız için 7/24 WhatsApp üzerinden bize ulaşabilirsiniz. Ekibimiz en kısa sürede dönüş yapacaktır.",
  "footer.contactSupportNote": "7/24 WhatsApp desteği — Ortalama yanıt süresi: 5 dakika",
  "footer.contactNotConfigured": "İletişim bilgileri henüz yapılandırılmadı.",
  "footer.cookiePolicy": "Çerez Politikası",
  "footer.kvkk": "KVKK Aydınlatma Metni",
  "footer.disclaimer": "Yasal Uyarı",
  "footer.whyLegalVio": "Neden LegalVio",
  "footer.support": "Destek Merkezi",
  "footer.netherlands": "Hollanda (BV)",
  "footer.ireland": "İrlanda (Ltd)",
  "footer.careers": "Kariyer",
  "footer.copyright": "Tüm hakları saklıdır.",
  "footer.description": "Yapay zeka destekli global LegalTech platformu. 150+ ülkede uluslararası şirket kuruluşu, vize hizmetleri ve iş geliştirme danışmanlığı. Global hukuk koordinasyon ortağınız.",
  "footer.newsletterTitle": "Gelişmelerden Haberdar Olun",
  "footer.newsletterDesc": "Uluslararası iş dünyası, hukuk gelişmeleri ve genişleme stratejileri hakkında en son bilgileri alın.",
  "footer.newsletterPlaceholder": "E-posta adresiniz",
  "footer.newsletterButton": "Abone Ol",
  "footer.newsletterSuccess": "Abone olduğunuz için teşekkürler!",
  "footer.newsletterError": "Bir şeyler yanlış gitti. Lütfen tekrar deneyin.",

  "cookie.title": "Çerez Tercihleri",
  "cookie.description": "Size daha iyi bir deneyim sunmak, kişiselleştirilmiş içerik sağlamak ve trafiğimizi analiz etmek için çerezler kullanıyoruz. \"Tümünü Kabul Et\" seçeneğine tıklayarak çerez kullanımımıza izin vermiş olursunuz.",
  "cookie.acceptAll": "Tümünü Kabul Et",
  "cookie.essentialOnly": "Sadece Gerekli Olanlar",
  "cookie.customize": "Özelleştir",
  "cookie.essential": "Zorunlu Çerezler",
  "cookie.essentialDesc": "Bu çerezler web sitesinin çalışması için gereklidir ve kapatılamaz.",
  "cookie.analytics": "Analitik Çerezler",
  "cookie.analyticsDesc": "Bu çerezler, ziyaret sayılarını ve trafik kaynaklarını ölçerek sitemizin performansını iyileştirmemize yardımcı olur.",
  "cookie.marketing": "Pazarlama Çerezleri",
  "cookie.marketingDesc": "Bu çerezler, reklam ortaklarımız tarafından ilgi alanlarınıza yönelik profil oluşturmak için sitemiz aracılığıyla ayarlanabilir.",
  "cookie.savePreferences": "Tercihleri Kaydet",

  "privacy.title": "Gizlilik Politikası",
  "terms.title": "Kullanım Koşulları",
  "cookies.title": "Çerez Politikası",

  "common.home": "Anasayfa",
  "common.loading": "Yükleniyor...",
  "common.error": "Bir şeyler yanlış gitti",
  "common.retry": "Tekrar Dene",
  "common.save": "Kaydet",
  "common.cancel": "İptal",
  "common.submit": "Gönder",
  "common.search": "Ara",
  "common.filter": "Filtrele",
  "common.clear": "Temizle",
  "common.back": "Geri",
  "common.next": "İleri",
  "common.previous": "Önceki",
  "common.details": "Detaylar",
  "common.learnMore": "Daha Fazla",
  "common.contactUs": "Bize Ulaşın",
  "common.getStarted": "Başlayın",
  "common.viewAll": "Tümünü Gör",
  "common.noResults": "Sonuç bulunamadı",
  "common.showMore": "Daha Fazla Göster",
  "common.showLess": "Daha Az Göster",
  "common.searchPlaceholder": "Sayfa, sekme veya eylem ara...",
  "common.selectItem": "Seç",
  "common.close": "Kapat",
  "common.delete": "Sil",
  "common.confirmDelete": "Silmek istediğinize emin misiniz?",
  "common.yesDelete": "Evet, Sil",
  "common.deleting": "Siliniyor...",
  "common.deleted": "Silindi!",

  "home.heroTitle": "Global Hukuk İstihbarat Ağınız",
  "home.heroSubtitle": "Uluslararası şirket kuruluşu, vize hizmetleri ve iş geliştirme için yapay zeka destekli platform. Tek platform, 150+ ülke, 300+ onaylı hukuk bürosu.",
  "home.heroCTA": "Ücretsiz Analiz Al",
  "home.heroSecondary": "Hizmetleri Keşfet",
  "home.servicesTitle": "Temel Hizmetler",
  "home.servicesSubtitle": "İşletmenizi global ölçekte büyütmek için ihtiyacınız olan her şey, yapay zeka ve uzman hukuk büroları ağı ile.",
  "home.statsTitle": "Dünya Çapında Güven",
  "home.processTitle": "Nasıl Çalışır",
  "home.partnersTitle": "Global Partner Ağı",
  "home.testimonialsTitle": "Müşteri Başarı Hikayeleri",

  "services.heroTitle": "Dünya Standartlarında Hukuk Hizmetleri, Tek Platform",
  "services.heroSubtitle": "Şirket kuruluşundan vize işlemlerine ve iş geliştirmeye, uluslararası yolculuğunuzun her aşamasını LegalVio koordine eder.",
  "services.companyFormation": "Uluslararası Şirket Kuruluşu",
  "services.visaImmigration": "Vize & Göçmenlik Hizmetleri",
  "services.businessExpansion": "İş Geliştirme Danışmanlığı",
  "services.moreSolutions": "Diğer Çözümler",
  "services.comprehensiveEcosystem": "Kapsamlı Hukuk Ekosistemi",
  "services.readyToGoGlobal": "Globalleşmeye Hazır mısınız?",
  "services.readyDesc": "Uluslararası genişleme ihtiyaçlarınız için ücretsiz, yükümlülük içermeyen bir analiz alın.",

  "language.en": "English",
  "language.tr": "Türkçe",
  "language.de": "Deutsch",
  "language.fr": "Français",
  "language.es": "Español",
  "language.it": "Italiano",
  "language.ar": "العربية",
  "language.ru": "Русский",
  "language.zh": "中文",
  "language.ja": "日本語",
  "language.ko": "한국어",

  "home.heroBadge": "Yapay Zeka Destekli LegalTech Platformu",
  "home.heroHeadline1": "Global Kurumsal",
  "home.heroHeadline2": "Hukuk İstihbarat",
  "home.heroHeadline3": "Ağı",
  "home.heroDescription": "150+ ülke, 300+ partner hukuk bürosu ve global şirket kuruluşu ile göçmenlik çözümleri için yapay zeka destekli iş koordinasyonu. Uluslararası hukuk hizmetlerine tek kapınız.",
  "home.heroCTA1": "Ülkeleri Keşfet",
  "home.heroCTA2": "Ücretsiz Analiz Al",
  "home.heroTrusted": "2.000+ müşteri tarafından güveniliyor",
  "home.heroCompliant": "GDPR & KVKK Uyumlu",
  "home.heroAvgResponse": "Ort. Yanıt Süresi",
  "home.heroCountriesCovered": "Kapsanan Ülke",
  "home.heroPartnerFirms": "Partner Hukuk Bürosu",
  "home.heroSuccessRate": "Başarı Oranı",
  "home.heroCompaniesFormed": "Kurulan Şirket",

  "faq.helpCenter": "Yardım Merkezi",
  "faq.heroTitle1": "Sıkça Sorulan",
  "faq.heroTitle2": "Sorular",
  "faq.heroDesc": "LegalVio'nun hizmetleri, süreci ve platformu hakkında bilmeniz gereken her şey. Aradığınızı bulamadınız mı? Ekibimiz yardıma hazır.",
  "faq.cat.0": "Şirket Kuruluşu",
  "faq.cat.1": "Vize & Göçmenlik",
  "faq.cat.2": "İş Geliştirme",
  "faq.cat.3": "Platform & Ortaklık",
  "faq.cat.4": "LegalTech & Yapay Zeka",
  "faq.cat.5": "Uyumluluk & Veri Gizliliği",
  "faq.stillHaveQuestions": "Hala Sorunuz mu Var?",
  "faq.stillHaveDesc": "Uzman ekibimiz yardıma hazır. Bize ulaşın, 4 saat içinde size dönüş yapalım.",
  "faq.contactUs": "Bize Ulaşın",
  "faq.exploreServices": "Hizmetleri Keşfet",

  // ── Services Main Page ──
  "svc.heroBadge": "Global Hukuk Hizmetleri",
  "svc.heroTitle1": "Dünya Standartlarında Hukuk Hizmetleri,",
  "svc.heroTitle2": "Tek Platform",
  "svc.heroDesc": "Şirket kuruluşundan vize işlemlerine ve iş geliştirmeye, uluslararası yolculuğunuzun her aşamasını LegalVio, yapay zeka hassasiyeti ve {{count}}+ onaylı hukuk bürosu ağıyla koordine eder.",
  "svc.formationTitle": "Uluslararası Şirket Kuruluşu",
  "svc.formationSubtitle": "İşletmenizi dünyanın her yerinde kurun",
  "svc.formationDesc": "150+ ülkede tam kapsamlı şirket kuruluşu hizmeti. Almanya'da GmbH'den ABD'de LLC'ye kadar, onaylı yerel ortaklarımız tüm hukuki detayları yönetirken AI platformumuz tüm süreci koordine eder.",
  "svc.visaTitle": "Vize & Göçmenlik Hizmetleri",
  "svc.visaSubtitle": "Küresel göçmenlik sürecinizi güvenle yönetin",
  "svc.visaDesc": "Yatırımcı vizeleri, startup vizeleri, çalışma izinleri ve Golden Visa programları için uzman rehberlik. AI destekli eşleştirme sistemimiz sizi durumunuza en uygun göçmenlik uzmanlarıyla buluşturur.",
  "svc.expansionTitle": "İş Geliştirme Danışmanlığı",
  "svc.expansionSubtitle": "İşletmenizi sınır ötesine taşıyın",
  "svc.expansionDesc": "Pazar giriş stratejisi, uluslararası uyumluluk, kurumsal yapılanma ve yatırım danışmanlığı. Karmaşık düzenleyici ortamlarda gezinmenize ve dünya çapında büyüme fırsatlarını belirlemenize yardımcı oluyoruz.",
  "svc.countries": "Ülke",
  "svc.formed": "Kurulan",
  "svc.partners": "Ortak",
  "svc.approved": "Onaylanan",
  "svc.markets": "Pazar",
  "svc.clients": "Müşteri",
  "svc.learnMore": "Detaylı Bilgi",
  "svc.moreSolutions": "Diğer Çözümler",
  "svc.comprehensiveEcosystem": "Kapsamlı Hukuk Ekosistemi",
  "svc.comprehensiveDesc": "Temel hizmetlerimizin ötesinde, LegalVio küresel iş ihtiyaçlarınız için tamamlayıcı çözümler sunar.",
  "svc.legalPartnerNetwork": "Hukuk Partner Ağı",
  "svc.legalPartnerNetworkDesc": "Sınır ötesi hukuki koordinasyon ve uzman danışmanlık için dünya çapında {{count}}+ onaylı hukuk bürosuna erişin.",
  "svc.investmentAdvisory": "Yatırım Danışmanlığı",
  "svc.investmentAdvisoryDesc": "Uluslararası girişimler, birleşme ve satın almalar ve sınır ötesi işlemler için stratejik yatırım rehberliği.",
  "svc.complianceManagement": "Uyumluluk Yönetimi",
  "svc.complianceManagementDesc": "Faaliyet gösterdiğiniz tüm bölgelerde sürekli düzenleyici uyumluluk izleme.",
  "svc.marketResearch": "Pazar Araştırması",
  "svc.marketResearchDesc": "Uluslararası genişleme için veri odaklı pazar analizi ve giriş fizibilite çalışmaları.",
  "svc.readyGlobal": "Globalleşmeye Hazır mısınız?",
  "svc.readyGlobalDesc": "Uluslararası genişleme ihtiyaçlarınız için ücretsiz, yükümlülük içermeyen bir analiz alın. AI destekli sistemimiz sizi 24 saat içinde en uygun çözümle eşleştirir.",
  "svc.getFreeAnalysis": "Ücretsiz Analiz Al",
  "svc.viewProcess": "Sürecimizi Görün",

  // ── Company Formation Page ──
  "cf.breadcrumb": "Hizmetler",
  "cf.badge": "Temel Hizmet",
  "cf.heroTitle1": "Uluslararası",
  "cf.heroTitle2": "Şirket Kuruluşu",
  "cf.heroDesc": "150+ ülkede onaylı yerel hukuk büroları ağımızla işletmenizi kurun. Almanya'da GmbH'den ABD'de LLC'ye kadar, siz büyümeye odaklanırken biz tüm hukuki detayları yönetiriz.",
  "cf.startFormation": "Kuruluşunuzu Başlatın",
  "cf.exploreCountries": "Ülkeleri Keşfedin",
  "cf.statCountries": "Ülke",
  "cf.statFormed": "Kurulan Şirket",
  "cf.statPartners": "Partner Firma",
  "cf.popularJurisdictions": "Popüler Bölgeler",
  "cf.chooseDestination": "Hedefinizi Seçin",
  "cf.chooseDesc": "Her bölge benzersiz avantajlar sunar. AI destekli sistemimiz, iş ihtiyaçlarınız için en uygun eşleşmeyi bulmanıza yardımcı olur.",
  "cf.minCapital": "Min. Sermaye",
  "cf.timeline": "Süre",
  "cf.processTitle": "Sürecimiz",
  "cf.howItWorks": "Şirket Kuruluşu Nasıl Çalışır",
  "cf.howDesc": "AI platformumuz tarafından yönetilen ve yerel hukuk uzmanları tarafından yürütülen akıcı bir süreç.",
  "cf.step1Title": "İlk Danışma",
  "cf.step1Desc": "İş hedeflerinizi analiz eder ve en uygun bölge ile şirket türünü öneririz.",
  "cf.step2Title": "Dokümantasyon",
  "cf.step2Desc": "Ortaklarımız gerekli tüm belgeleri hazırlar. Siz inceler ve gerekli bilgileri sağlarsınız.",
  "cf.step3Title": "Tescil",
  "cf.step3Desc": "Yerel hukuk bürosu yetkili mercilere tescil başvurusunu yapar. İlerlemeyi gerçek zamanlı takip ederiz.",
  "cf.step4Title": "Kuruluş Sonrası",
  "cf.step4Desc": "Banka hesabı açılışı, vergi kaydı ve sürekli uyumluluk desteği düzenlenir.",
  "cf.faqTitle": "Sıkça Sorulan Sorular",
  "cf.ctaTitle": "Şirket Kurmaya Hazır mısınız?",
  "cf.ctaDesc": "Şirket kuruluşu uzmanlarımızdan ücretsiz danışmanlık alın. İşletmeniz için doğru bölgeyi ve yapıyı seçmenize yardımcı olalım.",
  "cf.ctaButton": "Ücretsiz Danışmanlık Alın",
  "cf.countryStartNow": "Bu ülkede kur",
  "cf.midCTATitle": "İşletmenizi bugün kurmaya başlayın",
  "cf.midCTADesc": "Uzman ekibimiz tüm hukuki süreci sizin için yönetir. Siz sadece büyümeye odaklanın.",
  "cf.midCTAButton": "Hemen Başlayın",
  "cf.faqStillQuestions": "Aradığınız cevabı bulamadınız mı?",
  "cf.faqContactDesc": "Uzman ekibimiz tüm sorularınızı yanıtlamak için hazır.",
  "cf.faqContactButton": "Bize Ulaşın",

  // ── Visa & Immigration Page ──
  "vi.breadcrumb": "Hizmetler",
  "vi.badge": "Temel Hizmet",
  "vi.heroTitle1": "Vize &",
  "vi.heroTitle2": "Göçmenlik Hizmetleri",
  "vi.heroDesc": "Küresel göçmenlik sürecinizi güvenle yönetin. Yatırımcı Golden Visa'lardan startup ve dijital göçebe programlarına kadar, AI destekli platformumuz sizi en ideal yol ve onaylı göçmenlik uzmanlarıyla buluşturur.",
  "vi.startApplication": "Başvurunuzu Başlatın",
  "vi.explorePrograms": "Programları Keşfedin",
  "vi.statCountries": "Ülke",
  "vi.statApproved": "Onaylanan Vize",
  "vi.statSuccessRate": "Başarı Oranı",
  "vi.visaPrograms": "Vize Programları",
  "vi.findPathway": "Göçmenlik Yolunuzu Bulun",
  "vi.findPathwayDesc": "Yatırım bazlı oturumdan startup ve dijital göçebe programlarına kadar, profilinize uygun seçenekleri keşfedin.",
  "vi.investment": "Yatırım",
  "vi.immigrationJourney": "Göçmenlik Yolculuğunuz",
  "vi.immigrationJourneyDesc": "Göçmenlik uzmanları tarafından yönetilen ve AI platformumuzla desteklenen kapsamlı altı adımlı süreç.",
  "vi.step1Title": "Uygunluk Değerlendirmesi",
  "vi.step1Desc": "AI sistemimiz profilinizi vize programı gereksinimlerine göre değerlendirir ve en iyi seçenekleri belirler.",
  "vi.step2Title": "Belge Toplama",
  "vi.step2Desc": "Kapsamlı bir kontrol listesi sağlar ve gerekli tüm belgelerin toplanmasına yardımcı oluruz.",
  "vi.step3Title": "Başvuru Hazırlığı",
  "vi.step3Desc": "Yerel göçmenlik avukatları, maksimum başarı oranı için başvuru paketinizi hazırlar ve inceler.",
  "vi.step4Title": "Başvuru ve Takip",
  "vi.step4Desc": "Başvuru ilgili makamlara iletilir. İlerlemeyi takip eder ve takip taleplerini yönetiriz.",
  "vi.step5Title": "Vize Verilmesi",
  "vi.step5Desc": "Onay üzerine, vize işlemlerine yardımcı olur ve yerleşme sürecinizde size rehberlik ederiz.",
  "vi.step6Title": "Varış Sonrası Destek",
  "vi.step6Desc": "Oturma izinleri, vergi kaydı ve yerel entegrasyon için sürekli yardım.",
  "vi.faqTitle": "Göçmenlik Soruları",
  "vi.ctaTitle": "Göçmenlik Yolculuğunuza Başlayın",
  "vi.ctaDesc": "Göçmenlik uzmanlarımızdan ücretsiz danışmanlık randevusu alın. Uygunluğunuzu değerlendirelim ve hedefleriniz için en iyi vize yolunu önerelim.",
  "vi.ctaButton": "Ücretsiz Değerlendirme Alın",

  // ── Business Expansion Page ──
  "be.breadcrumb": "Hizmetler",
  "be.badge": "Temel Hizmet",
  "be.heroTitle1": "İş",
  "be.heroTitle2": "Geliştirme Danışmanlığı",
  "be.heroDesc": "İşletmenizi sınırlar ötesine güvenle taşıyın. Pazar giriş stratejisinden uyumluluk ve kurumsal yapılanmaya kadar, 100+ pazar uzmanından oluşan ağımız uluslararası genişlemenizin başarısını garanti eder.",
  "be.scheduleConsultation": "Danışmanlık Planlayın",
  "be.exploreServices": "Hizmetleri Keşfedin",
  "be.statMarkets": "Kapsanan Pazar",
  "be.statProjects": "Genişleme Projesi",
  "be.statRetention": "Müşteri Sadakati",
  "be.statValue": "Müşteriye Yaratılan Değer",
  "be.ourExpertise": "Uzmanlığımız",
  "be.comprehensiveSolutions": "Kapsamlı Genişleme Çözümleri",
  "be.comprehensiveDesc": "Uluslararası büyüme yolculuğunuzun her aşaması için uçtan uca danışmanlık hizmetleri.",
  "be.inquire": "Bu Hizmet Hakkında Bilgi Alın",
  "be.whatsIncluded": "Neler Dahil",
  "be.whyLegalVio": "Neden LegalVio",
  "be.advantage": "LegalVio Avantajı",
  "be.advantageDesc": "Genişleme danışmanlığımızı geleneksel yaklaşımlardan ayıran özellikler.",
  "be.advantage1Title": "AI Destekli Analiz",
  "be.advantage1Desc": "Platformumuz pazar verilerini, düzenleyici değişiklikleri ve rekabet istihbaratını işleyerek geleneksel danışmanlıktan daha hızlı eyleme dönüştürülebilir içgörüler sunar.",
  "be.advantage2Title": "100+ Pazar Ağı",
  "be.advantage2Desc": "Her büyük küresel pazarda onaylı uzmanlara erişin. Farklı bölgelerde birden fazla danışmanla çalışmanıza gerek kalmaz.",
  "be.advantage3Title": "Hızlandırılmış Zaman Çizelgesi",
  "be.advantage3Desc": "AI platformumuz ve yerel ortaklar tarafından koordine edilen paralel iş akışları sayesinde pazar giriş sürelerini %40-60 azaltın.",
  "be.advantage4Title": "Risk Azaltma",
  "be.advantage4Desc": "Tüm bölgelerde proaktif uyumluluk izleme ve risk değerlendirmesi, düzenleyici cezalara maruz kalma riskini azaltır.",
  "be.faqTitle": "Genişleme Soruları",
  "be.ctaTitle": "Birlikte Genişleyelim",
  "be.ctaDesc": "Genişleme uzmanlarımızla ücretsiz bir strateji oturumu planlayın. İş hedeflerinizi analiz edelim ve size özel bir uluslararası büyüme planı oluşturalım.",
  "be.ctaButton": "Strateji Oturumu Planlayın",

  // ── Partner Network Page ──
  "pn.badge": "Global Hukuk Ağı",
  "pn.heroTitle1": "Partner Hukuk Bürosu",
  "pn.heroTitle2": "Ağı",
  "pn.heroDesc": "{{countries}}+ ülkede {{count}}+ onaylı hukuk bürosu. AI destekli eşleştirme sistemimiz, özel ihtiyaçlarınız, bölgeniz ve sektörünüz için doğru hukuk ortağıyla sizi buluşturur.",
  "pn.statFirms": "Partner Firma",
  "pn.statCountries": "Ülke",
  "pn.statPracticeAreas": "Uzmanlık Alanı",
  "pn.statCoordination": "Koordinasyon",
  "pn.globalPresence": "Küresel Varlığımız",
  "pn.globalPresenceDesc": "Dünyanın her büyük finans ve iş merkezinde stratejik olarak konumlanmış partner hukuk büroları.",
  "pn.coverageTitle": "Bölgelere Göre Kapsam",
  "pn.coverageDesc": "Ağımız tüm kıtalara yayılmış olup, tüm büyük iş bölgelerinde güçlü bir varlığa sahiptir.",
  "pn.countries": "Ülke",
  "pn.firms": "Firma",
  "pn.directoryTitle": "Partner Dizini",
  "pn.directoryDesc": "Dünya çapındaki onaylı partner hukuk büroları ağımızı keşfedin.",
  "pn.allPracticeAreas": "Tüm Uzmanlık Alanları",
  "pn.partnerFound": "partner bulundu",
  "pn.partnersFound": "partner bulundu",
  "pn.viewProfile": "Profili Görüntüle",
  "pn.contact": "İletişim",
  "pn.joinNetwork": "Ağımıza Katılın",
  "pn.partnerWithUs": "LegalVio ile Ortak Olun",
  "pn.partnerDesc": "Uluslararası müşteri tabanınızı genişletmek isteyen bir hukuk bürosu musunuz? LegalVio partner ağına katılın ve nitelikli müşteri yönlendirmelerinden oluşan küresel bir akışa erişim kazanın.",
  "pn.benefit1": "Uluslararası müşteri yönlendirmelerine erişim",
  "pn.benefit2": "Uzmanlığınız için AI destekli vaka eşleştirme",
  "pn.benefit3": "White-label ortaklık seçenekleri",
  "pn.benefit4": "Gelir paylaşımlı yönlendirme modeli",
  "pn.benefit5": "Ortak markalı pazarlama fırsatları",
  "pn.applyAsPartner": "Partner Olarak Başvur",
  "pn.findPartner": "Hukuk Partnerinizi Bulun",
  "pn.findPartnerDesc": "Neye ihtiyacınız olduğunu söyleyin, AI destekli sistemimiz sizi küresel ağımızdan ideal partner hukuk bürosuyla eşleştirsin.",
  "pn.getMatched": "Hemen Eşleş",
  "pn.noPartnersYet": "Henüz hiç partner eklenmedi. Partner eklemek için admin panelini kullanın.",

  // ── Partner Apply Page ──
  "pa.title": "Partner Başvurusu",
  "pa.desc": "LegalVio'nun güvenilir hukuk büroları küresel ağına katılın. Aşağıdaki formu doldurun, ekibimiz başvurunuzu incelesin.",
  "pa.firmInfo": "Firma Bilgileri",
  "pa.firmName": "Firma Adı",
  "pa.practiceAreas": "Uzmanlık Alanları",
  "pa.country": "Ülke",
  "pa.city": "Şehir",
  "pa.website": "Web Sitesi",
  "pa.lawyerCount": "Avukat Sayısı",
  "pa.selectCountry": "Ülke seçin",
  "pa.contactPerson": "İletişim Kişisi",
  "pa.fullName": "Ad Soyad",
  "pa.email": "E-posta",
  "pa.phone": "Telefon",
  "pa.aboutFirm": "Firmanız Hakkında",
  "pa.aboutPlaceholder": "Firmanızın uzmanlığı, önemli davaları ve LegalVio ağına neden katılmak istediğiniz hakkında bilgi verin...",
  "pa.submit": "Başvuruyu Gönder",
  "pa.submitting": "Gönderiliyor...",
  "pa.successTitle": "Başvuru Gönderildi!",
  "pa.successDesc": "LegalVio partner ağına katılma talebiniz için teşekkür ederiz. Ekibimiz başvurunuzu inceleyecek ve 3-5 iş günü içinde size dönüş yapacaktır.",
  "pa.goDashboard": "Dashboard'a Git",
  "pa.viewPartnerNetwork": "Partner Ağını Görüntüle",
  "pa.errorFillRequired": "Lütfen tüm zorunlu alanları doldurun ve en az bir uzmanlık alanı seçin.",

  // ── Home StatsBar ──
  "stats.countries": "Ülke",
  "stats.partnerFirms": "Partner Hukuk Bürosu",
  "stats.companiesFormed": "Kurulan Şirket",
  "stats.clientSatisfaction": "Müşteri Memnuniyeti",
  "stats.avgResponse": "Ort. Yanıt Süresi",
  "stats.languages": "Desteklenen Dil",

  // ── Home ServiceCards ──
  "home.servicesBadge": "Hizmetlerimiz",
  "home.servicesTitleFull": "Uçtan Uca Global Hukuk Hizmetleri",
  "home.servicesDesc": "Şirket kuruluşundan vize işlemlerine kadar, AI destekli platformumuz uluslararası genişlemenizin her aşamasını onaylı yerel ortaklarla koordine eder.",

  // ── Home ProcessSection ──
  "home.processBadge": "Nasıl Çalışır",
  "home.processTitleFull": "Küresel Genişleme Yolculuğunuz",
  "home.processDesc": "İlk talepten sürekli uluslararası iş desteğine kadar sorunsuz bir altı adımlı süreç.",
  "home.prStep1Title": "Talep Oluşturun",
  "home.prStep1Desc": "İş hedeflerinizi, hedef ülkenizi ve hizmet ihtiyaçlarınızı detaylandıran basit bir form doldurun.",
  "home.prStep2Title": "Ücretsiz Analiz",
  "home.prStep2Desc": "AI destekli sistemimiz gereksinimlerinizi analiz eder ve sizi en uygun çözümlerle eşleştirir.",
  "home.prStep3Title": "Ülke & Hizmet Eşleştirme",
  "home.prStep3Desc": "Özel ihtiyaçlarınıza göre en iyi bölgeyi ve hizmet paketini belirleriz.",
  "home.prStep4Title": "Partner Hukuk Bürosu Ataması",
  "home.prStep4Desc": "Gereksinimlerinizde uzmanlaşmış onaylı bir yerel partner hukuk bürosuyla bağlantı kurarsınız.",
  "home.prStep5Title": "Kuruluş / Vize Süreci",
  "home.prStep5Desc": "Partner firma tüm hukuki prosedürleri yönetirken biz koordine eder ve ilerlemeyi izleriz.",
  "home.prStep6Title": "Süreç Sonrası Destek",
  "home.prStep6Desc": "Uluslararası operasyonlarınız için sürekli uyumluluk, muhasebe ve hukuki destek.",

  // ── Home JurisdictionCarousel ──
  "home.jurBadge": "Bölgeler",
  "home.jurTitle": "150+ Bölgeyi Keşfedin",
  "home.jurDesc": "Türkiye'den Dubai'ye, Estonya'dan ABD'ye — işletmeniz için en uygun bölgeyi bulun.",
  "home.jurPopular": "Popüler",

  // ── Home PartnerMapSection ──
  "home.partnersBadge": "Global Partner Ağı",
  "home.partnersTitle": "Dünya Çapında 300+ Onaylı Partner Hukuk Bürosu",
  "home.partnersDesc": "Özenle seçilmiş hukuk partnerleri ağımız altı kıtaya yayılmıştır. Her firma uzmanlık, güvenilirlik ve yerel pazar bilgisi açısından titizlikle incelenir — nerede faaliyet gösterirseniz gösterin dünya standartlarında hizmet almanızı sağlar.",
  "home.becomePartner": "Partner Hukuk Bürosu Olun",

  // ── Home TestimonialSection ──
  "home.testimonialsBadge": "Doğrulanmış Partner Değerlendirmesi",
  "home.testimonialsLabel": "Müşteri Başarı Hikayeleri",

  // ── Home CTASection ──
  "home.ctaTitle": "Globalleşmeye hazır mısınız?",
  "home.ctaDesc": "Uluslararası genişleme ihtiyaçlarınız için ücretsiz, yükümlülük içermeyen bir analiz alın. AI destekli sistemimiz sizi en uygun bölge ve hukuk partneriyle eşleştirecek.",
  "home.ctaConfidential": "Gizli & Güvenli",
  "home.ctaResponse": "4 saat içinde yanıt",
  "home.ctaLanguages": "11 dilde hizmet",
  "home.ctaFormTitle": "Ücretsiz Analiz Alın",
  "home.ctaFormDesc": "Formu doldurun, ekibimiz 4 saat içinde size dönüş yapacaktır.",
  "home.ctaFormName": "Ad Soyad",
  "home.ctaFormEmail": "E-posta",
  "home.ctaFormPhone": "Telefon",
  "home.ctaFormCountry": "Hedef Ülke",
  "home.ctaFormService": "İhtiyaç Duyulan Hizmet",
  "home.ctaFormMessage": "Mesaj",
  "home.ctaFormMessagePlaceholder": "Uluslararası genişleme ihtiyaçlarınız hakkında bilgi verin...",
  "home.ctaFormSubmitted": "Talep Gönderildi!",
  "home.ctaFormSubmittedDesc": "4 saat içinde size dönüş yapacağız. LegalVio'yu tercih ettiğiniz için teşekkür ederiz.",
  "home.ctaFormError": "Bir şeyler yanlış gitti. Lütfen tekrar deneyin.",
  "home.ctaFormNetworkError": "Ağ hatası. Lütfen bağlantınızı kontrol edip tekrar deneyin.",
  "home.ctaFormCharLimit": "Mesaj 500 karakteri aşamaz.",

  // ── Auth Pages ──
  "auth.welcomeBack": "Hoş Geldiniz",
  "auth.signInDesc": "Dashboard ve taleplerinize erişmek için giriş yapın.",
  "auth.emailAddress": "E-posta Adresi",
  "auth.password": "Şifre",
  "auth.enterPassword": "Şifrenizi girin",
  "auth.signIn": "Giriş Yap",
  "auth.signingIn": "Giriş yapılıyor...",
  "auth.noAccount": "Hesabınız yok mu?",
  "auth.createAccount": "Hesap Oluştur",
  "auth.createYourAccount": "Hesabınızı Oluşturun",
  "auth.signupDesc": "LegalVio ile küresel genişleme yolculuğunuza başlayın.",
  "auth.fullName": "Ad Soyad",
  "auth.confirmPassword": "Şifreyi Onayla",
  "auth.repeatPassword": "Şifrenizi tekrar girin",
  "auth.min6Chars": "En az 6 karakter",
  "auth.creatingAccount": "Hesap oluşturuluyor...",
  "auth.haveAccount": "Zaten hesabınız var mı?",
  "auth.fillAllFields": "Lütfen tüm alanları doldurun.",
  "auth.passwordMin6": "Şifre en az 6 karakter olmalıdır.",
  "auth.passwordsDontMatch": "Şifreler eşleşmiyor.",
  "auth.unexpectedError": "Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.",

  // ── Home CTASection ──
  "cta.title": "Globalleşmeye hazır mısınız?",
  "cta.description": "Uluslararası genişleme ihtiyaçlarınız için ücretsiz, yükümlülük içermeyen bir analiz alın. AI destekli sistemimiz sizi en uygun bölge ve hukuk partneriyle eşleştirecek.",
  "cta.confidential": "Gizli & Güvenli",
  "cta.response": "4 saat içinde yanıt",
  "cta.languages": "11 dilde hizmet",
  "cta.formTitle": "Ücretsiz Analiz Alın",
  "cta.formDesc": "Formu doldurun, ekibimiz 4 saat içinde size dönüş yapacaktır.",
  "cta.formName": "Ad Soyad *",
  "cta.formEmail": "E-posta *",
  "cta.formPhone": "Telefon",
  "cta.formCountry": "Hedef Ülke *",
  "cta.formService": "İhtiyaç Duyulan Hizmet *",
  "cta.formMessage": "Mesaj",
  "cta.formMessagePlaceholder": "Uluslararası genişleme ihtiyaçlarınız hakkında bilgi verin...",
  "cta.formSelectCountry": "Ülke seçin",
  "cta.formSelectService": "Hizmet seçin",
  "cta.formSubmitted": "Talep Gönderildi!",
  "cta.formSubmittedDesc": "4 saat içinde size dönüş yapacağız. LegalVio'yu tercih ettiğiniz için teşekkür ederiz.",
  "cta.formError": "Bir şeyler yanlış gitti. Lütfen tekrar deneyin.",
  "cta.formNetworkError": "Ağ hatası. Lütfen bağlantınızı kontrol edip tekrar deneyin.",
  "cta.formCharLimit": "Mesaj 500 karakteri aşamaz.",
  "cta.submitting": "Gönderiliyor...",
  "cta.getFreeAnalysis": "Ücretsiz Analiz Al",

  // ── Home PartnerMapSection ──
  "partners.badge": "Global Partner Ağı",
  "partners.titleLine1": "Dünya Çapında 300+ Onaylı",
  "partners.titleLine2": "Partner Hukuk Bürosu",
  "partners.description": "Özenle seçilmiş hukuk partnerleri ağımız altı kıtaya yayılmıştır. Her firma uzmanlık, güvenilirlik ve yerel pazar bilgisi açısından titizlikle incelenir — nerede faaliyet gösterirseniz gösterin dünya standartlarında hizmet almanızı sağlar.",
  "partners.becomePartner": "Partner Hukuk Bürosu Olun",

  // ── Dashboard ──
  "dash.welcomeBack": "Hoş geldin,",
  "dash.trackJourney": "Küresel genişleme yolculuğunuzu takip edin ve hizmet taleplerinizi yönetin.",
  "dash.totalRequests": "Toplam Talep",
  "dash.pending": "Beklemede",
  "dash.inProgress": "Devam Ediyor",
  "dash.completed": "Tamamlandı",
  "dash.newRequest": "Yeni Hizmet Talebi",
  "dash.viewAllRequests": "Tüm Talepleri Gör",
  "dash.recentRequests": "Son Talepler",
  "dash.viewAll": "Tümünü Gör",
  "dash.loadingRequests": "Talepler yükleniyor...",
  "dash.failedToLoad": "Talepler yüklenemedi.",
  "dash.tryAgain": "Tekrar Dene",
  "dash.noRequests": "Henüz talep yok",
  "dash.noRequestsDesc": "İlk hizmet talebinizi oluşturun ve küresel genişleme yolculuğunuza başlayın.",
  "dash.createRequest": "Talep Oluştur",
  "dash.viewDetails": "Detayları Gör",
  "dash.service": "Hizmet",
  "dash.country": "Ülke",
  "dash.status": "Durum",
  "dash.date": "Tarih",
  "dash.action": "İşlem",
  "dash.myRequests": "Taleplerim",
  "dash.profile": "Profil",
  "dash.signOut": "Çıkış Yap",
  "dash.cancelled": "İptal Edildi",
  "dash.userFallback": "hoş geldiniz",
  "dash.documents": "Belgeler",

  // ── Admin Panel Labels ──
  "admin.dashboard": "Dashboard",
  "admin.requests": "Talepler",
  "admin.users": "Kullanıcılar",
  "admin.applications": "Başvurular",
  "admin.blog": "Blog",
  "admin.faq": "SSS",
  "admin.partners": "Partnerler",
  "admin.testimonials": "Referanslar",
  "admin.audit": "Denetim Kaydı",
  "admin.settings": "Ayarlar",
  "admin.jurisdictions": "Bölgeler",
  "admin.adminPanel": "Yönetim Paneli",
  "admin.manageDesc": "Talepleri, kullanıcıları ve partner başvurularını yönetin.",
  "admin.loadingData": "Veriler yükleniyor...",
  "admin.failedToLoad": "Veriler yüklenemedi.",
  "admin.retry": "Tekrar Dene",
  "admin.signOut": "Çıkış Yap",
  "admin.tabs.dashboard": "Dashboard",
  "admin.tabs.requests": "Talepler",
  "admin.tabs.users": "Kullanıcılar",
  "admin.tabs.applications": "Başvurular",
  "admin.tabs.blog": "Blog",
  "admin.tabs.faq": "SSS",
  "admin.tabs.partners": "Partnerler",
  "admin.tabs.testimonials": "Referanslar",
  "admin.tabs.audit": "Denetim Kaydı",
  "admin.tabs.settings": "Ayarlar",
  "admin.tabs.jurisdictions": "Bölgeler",
  "admin.tabs.pricing": "Fiyatlandırma",
  "admin.tabs.documents": "Belgeler",
  "admin.tabs.serviceContent": "Servis İçeriği",
  "admin.tabs.notifications": "Bildirimler",
  "admin.tabs.seo": "SEO Yönetimi",
  "admin.tabs.schemas": "Schema Yönetimi",
  "admin.tabs.navigation": "Menü Yönetimi",
  "admin.tabs.geo": "GEO Yönetimi",
  "admin.tabs.aiVisibility": "AI Görünürlük",
  "admin.tabs.media": "Medya Kütüphanesi",
  "admin.tabs.emailTemplates": "E-posta Şablonları",
  "admin.tabs.analytics": "Analitik Raporlar",
  "admin.tabs.templateLibrary": "Şablon Kütüphanesi",
  "admin.tabs.footerManagement": "Footer Yönetimi",
  "admin.tabs.headerManagement": "Header Yönetimi",
  "admin.tabs.linkHealth": "Link Sağlığı",
  "admin.status.pending": "Beklemede",
  "admin.status.inProgress": "Devam Ediyor",
  "admin.status.completed": "Tamamlandı",
  "admin.status.cancelled": "İptal Edildi",
  "admin.status.approved": "Onaylandı",
  "admin.status.rejected": "Reddedildi",
  "admin.service.companyFormation": "Şirket Kuruluşu",
  "admin.service.visaImmigration": "Vize & Göçmenlik",
  "admin.service.businessExpansion": "İş Geliştirme",
  "admin.service.legalConsulting": "Hukuk Danışmanlığı",
  "admin.common.manage": "Yönet",
  "admin.common.save": "Değişiklikleri Kaydet",
  "admin.common.cancel": "İptal",
  "admin.common.create": "Oluştur",
  "admin.common.delete": "Sil",
  "admin.common.close": "Kapat",
  "admin.common.search": "Ara",
  "admin.common.clear": "Temizle",
  "admin.common.showing": "Gösteriliyor",
  "admin.common.of": "/",
  "admin.common.na": "Yok",
  "admin.common.notSpecified": "Belirtilmemiş",
  "admin.common.noDescription": "Açıklama yok",
  "admin.common.all": "Tümü",
  "admin.common.saving": "Kaydediliyor...",
  "admin.common.saved": "Kaydedildi!",
  "admin.common.loading": "Yükleniyor...",
  "admin.common.noResults": "Sonuç bulunamadı",
  "admin.requestModal.title": "Talebi Yönet",
  "admin.requestModal.contactEmail": "İletişim E-postası",
  "admin.requestModal.phone": "Telefon",
  "admin.requestModal.showDetails": "Tüm detayları göster",
  "admin.requestModal.hideDetails": "Detayları gizle",
  "admin.requestModal.company": "Şirket",
  "admin.requestModal.description": "Açıklama",
  "admin.requestModal.budget": "Bütçe",
  "admin.requestModal.timeline": "Zaman Çizelgesi",
  "admin.requestModal.updateStatus": "Durumu Güncelle",
  "admin.requestModal.adminNotes": "Yönetici Notları",
  "admin.requestModal.addNotes": "Dahili not ekleyin...",
  "admin.appModal.title": "Başvuruyu Yönet",
  "admin.appModal.lawyers": "Avukat",
  "admin.appModal.website": "Web Sitesi",
  "admin.appModal.practiceAreas": "Uzmanlık Alanları",
  "admin.appModal.firmDesc": "Firma Açıklaması",
  "admin.appModal.contactPerson": "İletişim Kişisi",
  "admin.appModal.name": "Ad",
  "admin.appModal.email": "E-posta",
  "admin.appModal.phone": "Telefon",
  "admin.appModal.updateStatus": "Durumu Güncelle",
  "admin.appModal.adminNotes": "Yönetici Notları",
  "admin.appModal.addNotes": "Dahili not ekleyin...",
  "admin.userModal.profileInfo": "Profil Bilgisi",
  "admin.userModal.requests": "Talepler",
  "admin.userModal.fullName": "Ad Soyad",
  "admin.userModal.email": "E-posta",
  "admin.userModal.company": "Şirket",
  "admin.userModal.phone": "Telefon",
  "admin.userModal.country": "Ülke",
  "admin.userModal.role": "Rol",
  "admin.userModal.joined": "Katılım",
  "admin.userModal.noRequests": "Bu kullanıcının talebi yok.",
  "admin.userModal.unnamedUser": "İsimsiz Kullanıcı",
  "admin.requestsTab.searchPlaceholder": "Taleplerde ara...",
  "admin.requestsTab.allServices": "Tüm Hizmetler",
  "admin.requestsTab.allStatuses": "Tüm Durumlar",
  "admin.requestsTab.allCountries": "Tüm Ülkeler",
  "admin.requestsTab.noMatch": "Filtrelere uyan talep yok.",
  "admin.requestsTab.noRequests": "Talep bulunamadı.",
  "admin.requestsTab.service": "Hizmet",
  "admin.requestsTab.country": "Ülke",
  "admin.requestsTab.contact": "İletişim",
  "admin.requestsTab.status": "Durum",
  "admin.requestsTab.date": "Tarih",
  "admin.requestsTab.action": "İşlem",
  "admin.applicationsTab.searchPlaceholder": "Firma, kişi, uzmanlık alanı ara...",
  "admin.applicationsTab.allStatuses": "Tüm Durumlar",
  "admin.applicationsTab.allCountries": "Tüm Ülkeler",
  "admin.applicationsTab.noMatch": "Filtrelere uyan başvuru yok.",
  "admin.applicationsTab.noApps": "Partner başvurusu bulunamadı.",
  "admin.applicationsTab.firm": "Firma",
  "admin.applicationsTab.location": "Konum",
  "admin.applicationsTab.practiceAreas": "Uzmanlık Alanları",
  "admin.applicationsTab.contact": "İletişim",
  "admin.applicationsTab.status": "Durum",
  "admin.applicationsTab.action": "İşlem",
  "admin.applicationsTab.lawyers_one": "avukat",
  "admin.applicationsTab.lawyers_other": "avukat",
  "admin.applicationsTab.date": "Tarih",
  "admin.blogTab.searchPlaceholder": "Yazılarda ara...",
  "admin.blogTab.allCategories": "Tüm Kategoriler",
  "admin.blogTab.allStatuses": "Tüm Durumlar",
  "admin.blogTab.newPost": "Yeni Yazı",
  "admin.blogTab.editPost": "Blog Yazısını Düzenle",
  "admin.blogTab.createPost": "Yazı Oluştur",
  "admin.blogTab.cancel": "İptal",
  "admin.blogTab.saveChanges": "Değişiklikleri Kaydet",
  "admin.blogTab.title": "Başlık",
  "admin.blogTab.slug": "Slug",
  "admin.blogTab.excerpt": "Özet",
  "admin.blogTab.category": "Kategori",
  "admin.blogTab.status": "Durum",
  "admin.blogTab.featured": "Öne Çıkan",
  "admin.blogTab.author": "Yazar",
  "admin.blogTab.role": "Rol",
  "admin.blogTab.avatar": "Avatar (kısaltma)",
  "admin.blogTab.date": "Tarih",
  "admin.blogTab.readTime": "Okuma Süresi",
  "admin.blogTab.imageUrl": "Kapak Görseli",
  "admin.blogTab.tags": "Etiketler (virgülle ayırın)",
  "admin.blogTab.relatedSlugs": "İlgili Yazı Slug'ları (virgülle ayırın)",
  "admin.blogTab.sections": "Bölümler",
  "admin.blogTab.addSection": "Bölüm Ekle",
  "admin.blogTab.section_one": "Bölüm {{n}}",
  "admin.blogTab.sectionHeading": "Bölüm başlığı",
  "admin.blogTab.sectionContent": "Bölüm içeriği",
  "admin.blogTab.published": "Yayında",
  "admin.blogTab.draft": "Taslak",
  "admin.blogTab.loading": "Blog yazıları yükleniyor...",
  "admin.blogTab.noMatch": "Filtrelere uyan yazı yok.",
  "admin.blogTab.noPosts": "Henüz blog yazısı yok.",
  "admin.blogTab.actions": "İşlemler",
  "admin.blogTab.deleteConfirm": "Bu blog yazısını kalıcı olarak silmek istediğinize emin misiniz?",
  "admin.blogTab.deleteFailed": "Silme başarısız",
  "admin.blogTab.saveFailed": "Kaydetme başarısız",
  "admin.blogTab.requiredFields": "Başlık, slug ve özet zorunludur.",
  "admin.usersTab.searchPlaceholder": "Kullanıcıları ada, e-postaya, şirkete göre ara...",
  "admin.usersTab.user": "Kullanıcı",
  "admin.usersTab.company": "Şirket",
  "admin.usersTab.country": "Ülke",
  "admin.usersTab.requests": "Talepler",
  "admin.usersTab.role": "Rol",
  "admin.usersTab.joined": "Katılım",
  "admin.usersTab.actions": "İşlemler",
  "admin.usersTab.details": "Detaylar",
  "admin.usersTab.noMatch": "Aramaya uyan kullanıcı yok.",
  "admin.usersTab.noUsers": "Kullanıcı bulunamadı.",
  "admin.usersTab.deleteUser": "Kullanıcıyı Sil",
  "admin.usersTab.deleteTitle": "Kullanıcı Silinsin mi?",
  "admin.usersTab.deleteDesc": "Bu işlem geri alınamaz. Bu kullanıcıya ait tüm veriler kalıcı olarak silinecektir.",
  "admin.usersTab.deleting": "Siliniyor...",
  "admin.blogTab.categories.0": "Şirket Kuruluşu",
  "admin.blogTab.categories.1": "Vize & Göçmenlik",
  "admin.blogTab.categories.2": "İş Geliştirme",
  "admin.blogTab.categories.3": "LegalTech",
  "admin.blogTab.categories.4": "Uyumluluk",

  // ── Scroll indicator ──
  "home.scroll": "Aşağı Kaydır",
  "home.scrollLeft": "Sola kaydır",
  "home.scrollRight": "Sağa kaydır",

  // ── Dashboard Request New ──
  "reqNew.title": "Yeni Hizmet Talebi",
  "reqNew.subtitle": "İhtiyaçlarınızı bize iletin, size en uygun partneri atayalım.",
  "reqNew.myRequests": "Taleplerim",
  "reqNew.profile": "Profil",
  "reqNew.serviceType": "Hizmet Türü",
  "reqNew.targetCountry": "Hedef Ülke",
  "reqNew.companyName": "Şirket Adı",
  "reqNew.email": "E-posta",
  "reqNew.phone": "Telefon",
  "reqNew.description": "Açıklama",
  "reqNew.budgetRange": "Bütçe Aralığı",
  "reqNew.timeline": "Zaman Çizelgesi",
  "reqNew.submit": "Talebi Gönder",
  "reqNew.submitting": "Gönderiliyor...",
  "reqNew.characters": "karakter",
  "reqNew.requiredFields": "Lütfen tüm zorunlu alanları doldurun (Hizmet Türü, Ülke, E-posta, Açıklama).",
  "reqNew.charLimit": "Açıklama 500 karakteri aşamaz.",
  "reqNew.unexpectedError": "Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.",
  "reqNew.successTitle": "Talep Gönderildi!",
  "reqNew.successDesc": "Hizmet talebiniz oluşturuldu. Ekibimiz inceleyip en kısa sürede size dönüş yapacaktır.",
  "reqNew.redirecting": "Taleplerinize yönlendiriliyorsunuz...",
  "reqNew.selectCountry": "Ülke seçin...",
  "reqNew.selectBudget": "Bütçe aralığı seçin...",
  "reqNew.selectTimeline": "Zaman çizelgesi seçin...",
  "reqNew.companyPlaceholder": "Şirket veya proje adınız",
  "reqNew.emailPlaceholder": "siz@sirket.com",
  "reqNew.phonePlaceholder": "+90 555 123 4567",
  "reqNew.descPlaceholder": "İhtiyaçlarınızı, hedeflerinizi ve özel gereksinimlerinizi açıklayın...",
  "reqNew.serviceCompanyFormation": "Şirket Kuruluşu",
  "reqNew.serviceVisaImmigration": "Vize & Göçmenlik",
  "reqNew.serviceBusinessExpansion": "İş Geliştirme",
  "reqNew.serviceLegalConsulting": "Hukuk Danışmanlığı",
  "reqNew.budgetUnder5k": "€5.000 altı",
  "reqNew.budget5k10k": "€5.000 - €10.000",
  "reqNew.budget10k25k": "€10.000 - €25.000",
  "reqNew.budget25k50k": "€25.000 - €50.000",
  "reqNew.budget50k100k": "€50.000 - €100.000",
  "reqNew.budgetOver100k": "€100.000 üzeri",
  "reqNew.budgetNotSure": "Henüz emin değilim",
  "reqNew.timeline1Month": "1 ay içinde",
  "reqNew.timeline1to3": "1-3 ay",
  "reqNew.timeline3to6": "3-6 ay",
  "reqNew.timeline6to12": "6-12 ay",
  "reqNew.timelineFlexible": "Esnek / Keşif aşamasında",

  // ── Dashboard Profile ──
  "profile.title": "Profilim",
  "profile.subtitle": "Kişisel bilgilerinizi ve tercihlerinizi yönetin.",
  "profile.dashboard": "Dashboard",
  "profile.myRequests": "Taleplerim",
  "profile.signOut": "Çıkış Yap",
  "profile.fullName": "Ad Soyad",
  "profile.email": "E-posta",
  "profile.company": "Şirket",
  "profile.phone": "Telefon",
  "profile.country": "Ülke",
  "profile.user": "Kullanıcı",
  "profile.admin": "Yönetici",
  "profile.emailCantChange": "E-posta değiştirilemez.",
  "profile.saving": "Kaydediliyor...",
  "profile.updated": "Profil Güncellendi!",
  "profile.save": "Değişiklikleri Kaydet",
  "profile.selectCountry": "Ülke seçin",
  "profile.fullNamePlaceholder": "Adınız soyadınız",
  "profile.companyPlaceholder": "Şirket adınız",
  "profile.phonePlaceholder": "Telefon numaranız",
  "profile.changePassword": "Şifre Değiştir",
  "profile.currentPassword": "Mevcut Şifre",
  "profile.newPassword": "Yeni Şifre",
  "profile.confirmNewPassword": "Yeni Şifre (Tekrar)",
  "profile.passwordMin6": "Şifre en az 6 karakter olmalıdır.",
  "profile.passwordsDontMatch": "Şifreler eşleşmiyor.",
  "profile.passwordChanged": "Şifreniz başarıyla değiştirildi.",
  "profile.passwordChangeError": "Şifre değiştirilemedi. Mevcut şifrenizi kontrol edin.",
  "profile.deleteAccount": "Hesabı Sil",
  "profile.deleteAccountTitle": "Hesabınızı Silmek İstediğinize Emin misiniz?",
  "profile.deleteAccountDesc": "Bu işlem geri alınamaz. Tüm verileriniz, talepleriniz ve belgeleriniz kalıcı olarak silinecektir.",
  "profile.deleteAccountConfirm": "Hesabımı Sil",
  "profile.deleteAccountSuccess": "Hesabınız başarıyla silindi. Bizi tercih ettiğiniz için teşekkür ederiz.",
  "profile.deleteAccountError": "Hesap silinemedi. Lütfen destek ekibiyle iletişime geçin.",
  "profile.changingPassword": "Değiştiriliyor...",
  "profile.passwordSection": "Güvenlik",
  "profile.dangerZone": "Tehlikeli Bölge",
  "profile.passwordRequirements": "En az 6 karakter, büyük harf ve rakam içermelidir.",

  // ── Partner Apply (additional) ──
  "pa.countryLabel": "Ülke",
  "pa.loadingCountries": "Ülkeler yükleniyor...",

  // ── Pricing Page ──
  "pricing.badge": "Şeffaf Fiyatlandırma",
  "pricing.title": "Planınızı Seçin",
  "pricing.description": "Uluslararası genişlemenizin her aşaması için şeffaf fiyatlandırma. Gizli ücret yok, sürpriz yok.",
  "pricing.all": "Tüm Planlar",
  "pricing.companyFormation": "Şirket Kuruluşu",
  "pricing.visaImmigration": "Vize & Göçmenlik",
  "pricing.businessExpansion": "İş Geliştirme",
  "pricing.popular": "En Popüler",
  "pricing.getStarted": "Başlayın",
  "pricing.noPlans": "Bu kategoride henüz plan yok.",
  "pricing.faqTitle": "Sıkça Sorulan Sorular",
  "pricing.faqDesc": "Fiyatlandırma ve ödeme sürecimiz hakkında bilmeniz gereken her şey.",
  "pricing.contactSales": "Satış Ekibiyle Görüşün",
  "pricing.viewFAQ": "Tüm SSS'leri Gör",

  // ── Navbar ──
  "nav.pricing": "Fiyatlandırma",

  // ── Dashboard Requests List ──
  "reqList.title": "Taleplerim",
  "reqList.subtitle": "Tüm hizmet taleplerinizi takip edin ve yönetin.",
  "reqList.newRequest": "Yeni Talep",
  "reqList.profile": "Profil",
  "reqList.dashboard": "← Dashboard",
  "reqList.all": "Tümü",
  "reqList.pending": "Beklemede",
  "reqList.inProgress": "Devam Ediyor",
  "reqList.completed": "Tamamlandı",
  "reqList.cancelled": "İptal Edildi",
  "reqList.loading": "Talepler yükleniyor...",
  "reqList.loadingError": "Talepler yüklenemedi.",
  "reqList.tryAgain": "Tekrar Dene",
  "reqList.noRequests": "Henüz talep bulunamadı",
  "reqList.noRequestsFilter": "Bu filtreyle eşleşen talep yok. Farklı bir durum deneyin.",
  "reqList.noRequestsStart": "İlk hizmet talebinizi oluşturarak başlayın.",
  "reqList.createRequest": "Talep Oluştur",
  "reqList.deleteRequest": "Talebi Sil",
  "reqList.deleteConfirm": "Bu talebi kalıcı olarak silmek istediğinize emin misiniz?",
  "reqList.deleting": "Siliniyor...",
  "reqList.created": "Oluşturuldu",
  "reqList.serviceCompanyFormation": "Şirket Kuruluşu",
  "reqList.serviceVisaImmigration": "Vize & Göçmenlik",
  "reqList.serviceBusinessExpansion": "İş Geliştirme",
  "reqList.serviceLegalConsulting": "Hukuk Danışmanlığı",

  // ── Dashboard Request Detail ──
  "reqDetail.title": "Talep Durumu",
  "reqDetail.details": "Talep Detayları",
  "reqDetail.timeline": "Zaman Çizelgesi",
  "reqDetail.backToRequests": "← Taleplerim",
  "reqDetail.profile": "Profil",
  "reqDetail.cancelRequest": "Talebi İptal Et",
  "reqDetail.cancelling": "İptal ediliyor...",
  "reqDetail.deleteRequest": "Talebi Sil",
  "reqDetail.deleting": "Siliniyor...",
  "reqDetail.deleteConfirm": "Bu talebi kalıcı olarak silmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
  "reqDetail.notFound": "Talep bulunamadı veya erişim reddedildi.",
  "reqDetail.loadError": "Talep detayları yüklenemedi.",
  "reqDetail.backToRequestsBtn": "Taleplere Dön",
  "reqDetail.loading": "Talep yükleniyor...",
  "reqDetail.serviceType": "Hizmet Türü",
  "reqDetail.targetCountry": "Hedef Ülke",
  "reqDetail.companyName": "Şirket Adı",
  "reqDetail.contactEmail": "İletişim E-postası",
  "reqDetail.contactPhone": "İletişim Telefonu",
  "reqDetail.budgetRange": "Bütçe Aralığı",
  "reqDetail.timelineLabel": "Zaman Çizelgesi",
  "reqDetail.description": "Açıklama",
  "reqDetail.teamNotes": "Ekip Notları",
  "reqDetail.requestCreated": "Talep Oluşturuldu",
  "reqDetail.statusPending": "Beklemede",
  "reqDetail.statusInProgress": "Devam Ediyor",
  "reqDetail.statusCompleted": "Tamamlandı",
  "reqDetail.statusCancelled": "İptal Edildi",
  "reqDetail.cancelledNotice": "Bu talep iptal edilmiştir.",
  "reqDetail.pendingDesc": "Talebiniz alındı ve inceleme bekliyor.",
  "reqDetail.inProgressDesc": "Ekibimiz talebiniz üzerinde aktif olarak çalışıyor.",
  "reqDetail.completedDesc": "Talebiniz başarıyla tamamlandı.",

  // ── Contact Page: Neden LegalVio ──
  "contact.whyLegalVioTitle": "Neden LegalVio?",
  "contact.whyLegalVio.0": "4 saat içinde yanıt garantisi",
  "contact.whyLegalVio.1": "150+ ülkede hizmet",
  "contact.whyLegalVio.2": "{{count}}+ onaylı hukuk bürosu",
  "contact.whyLegalVio.3": "11 dilde destek",
  "contact.whyLegalVio.4": "GDPR & KVKK uyumlu",

  // ── Free Analysis Page: Analiz Kapsamı ──
  "freeAnalysis.scope.title": "Analiz Kapsamı",
  "freeAnalysis.scope.0.title": "Optimal Bölge Analizi",
  "freeAnalysis.scope.0.desc": "İş hedeflerinize en uygun 3 ülke önerisi",
  "freeAnalysis.scope.1.title": "Şirket Türü Önerisi",
  "freeAnalysis.scope.1.desc": "Vergi avantajları ve uyumluluk değerlendirmesi",
  "freeAnalysis.scope.2.title": "Maliyet Projeksiyonu",
  "freeAnalysis.scope.2.desc": "Kurulum ve operasyonel maliyet karşılaştırması",
  "freeAnalysis.scope.3.title": "Zaman Çizelgesi",
  "freeAnalysis.scope.3.desc": "Aşamalı kurulum ve genişleme takvimi",
  "freeAnalysis.scope.4.title": "Partner Eşleştirme",
  "freeAnalysis.scope.4.desc": "Profesyonel ihtiyaçlarınıza özel hukuk bürosu",

  // ── Careers Page: Neden LegalVio ──
  "careers.whyLegalVioTitle": "Neden LegalVio?",
  "careers.whyLegalVio.0.title": "Global Etki",
  "careers.whyLegalVio.0.desc": "80+ ülkede faaliyet gösteren bir platformda çalışarak uluslararası deneyim kazanın.",
  "careers.whyLegalVio.1.title": "Hızlı Büyüme",
  "careers.whyLegalVio.1.desc": "Hızla büyüyen bir LegalTech girişiminde kariyerinizi hızlandırın.",
  "careers.whyLegalVio.2.title": "Esnek Çalışma",
  "careers.whyLegalVio.2.desc": "Uzaktan ve hibrit çalışma seçenekleriyle iş-yaşam dengenizi koruyun.",
  "careers.whyLegalVio.3.title": "İnovasyon Kültürü",
  "careers.whyLegalVio.3.desc": "AI ve hukuk teknolojilerinin kesişiminde yenilikçi projeler geliştirin.",

  "careers.heroBadge": "Ekibimize Katılın",
  "careers.heroTitle1": "Dünyayı Değiştiren",
  "careers.heroTitle2": "Ekibe Katılın",
  "careers.heroDesc": "Global hukuk teknolojilerinin geleceğini şekillendiren, 11 dilde hizmet veren ve 80+ ülkede faaliyet gösteren bir LegalTech platformuyuz.",
  "careers.heroStatLang": "Dil",
  "careers.heroStatCountries": "Ülke",
  "careers.heroStatTeam": "Ekip Üyesi",
  "careers.lifeBadge": "LegalVio'da Yaşam",
  "careers.openPositionsBadge": "Açık Pozisyonlar",
  "careers.openPositionsTitle": "Size Uygun Pozisyonu Bulun",
  "careers.noPositions": "Bu kategoride açık pozisyon bulunmamaktadır.",
  "careers.requirements": "Aranan Nitelikler",
  "careers.applyNow": "Bu Pozisyona Başvur",
  "careers.applyBadge": "Başvuru",
  "careers.applyTitle": "Bize Katılın",
  "careers.applyDesc": "Size uygun pozisyonu bulamadınız mı? Yine de başvurun — genel başvuruları her zaman değerlendiriyoruz.",
  "careers.successTitle": "Başvurunuz Alındı!",
  "careers.successDesc": "Başvurunuzu inceledikten sonra uygun görülmesi halinde sizinle iletişime geçeceğiz.",
  "careers.newApplication": "Yeni Başvuru Yap",
  "careers.formName": "Ad Soyad *",
  "careers.formEmail": "E-posta *",
  "careers.formPhone": "Telefon",
  "careers.formPosition": "Pozisyon *",
  "careers.formMessage": "Mesaj / Ön Yazı",
  "careers.formNamePh": "Adınız soyadınız",
  "careers.formEmailPh": "siz@email.com",
  "careers.formPhonePh": "+90 555 123 4567",
  "careers.formPositionPh": "Pozisyon seçin...",
  "careers.formMessagePh": "Kendinizden ve neden LegalVio'ya katılmak istediğinizden bahsedin...",
  "careers.formGeneral": "Genel Başvuru",
  "careers.charCount": "karakter",
  "careers.formRequired": "Lütfen ad soyad, e-posta ve pozisyon alanlarını doldurun.",
  "careers.formCharLimit": "Mesaj 500 karakteri aşamaz.",
  "careers.formError": "Bir şeyler yanlış gitti. Lütfen tekrar deneyin.",
  "careers.formSubmitting": "Gönderiliyor...",
  "careers.formSubmit": "Başvuruyu Gönder",
  "careers.breadcrumb": "Kariyer",

  "careers.heroStatLangVal": "11",
  "careers.heroStatCountriesVal": "80+",
  "careers.heroStatTeamVal": "50+",
}